import { FC, useCallback, useEffect, useRef, useState } from 'react';
import IconSearch from '@shared/icons/IconSearch';
import { debounce } from 'lodash';
import IconCross from '@shared/icons/IconCross';

interface ISearchProps {
  backgroundColor?: string;
  search: string;
  onSearch: (value: string) => void;
}

const Search: FC<ISearchProps> = ({ backgroundColor, onSearch }) => {
  const [inputFocus, setInputFocus] = useState(false);
  const textInput = useRef<HTMLInputElement>(null);
  const [value, setValue] = useState('');

  const setFocus = useCallback(() => {
    textInput?.current?.focus();
  }, []);

  const handleSearchDebounce = useRef(
    debounce(async value => {
      await onSearch(value);
    }, 600)
  ).current;

  useEffect(() => {
    return () => {
      handleSearchDebounce.cancel();
    };
  }, [handleSearchDebounce]);

  const onBlur = () => {
    if (value.length) return;
    setInputFocus(false);
  };

  return (
    <div className="relative" onFocus={() => setInputFocus(true)} onBlur={() => onBlur()}>
      <input
        ref={textInput}
        value={value}
        className={`
                    w-[173px] 
                    w-full 
                    h-[33px]
                    box-border 
                    border 
                    border-solid 
                    border-opacity-30 
                    rounded-[8px] 
                    border-[#959595] 
                    px-[15px] 
                    outline-none
                    ${backgroundColor ? 'bg-[' + backgroundColor + ']' : 'bg-[#141316]'}
                `}
        onChange={({ target: { value } }) => {
          setValue(value);
          handleSearchDebounce(value);
        }}
      />
      {!inputFocus || !value.length ? (
        <div
          onClick={() => setFocus()}
          className={`absolute top-[6px] left-[15px] flex gap-[5px] items-center text-[#959595]`}
        >
          <IconSearch />
          <span>Поиск</span>
        </div>
      ) : null}

      {value.length ? (
        <span
          className="absolute right-[5px] top-[10px] cursor-pointer"
          onClick={() => {
            onSearch('');
            setValue('');
          }}
        >
          <IconCross />
        </span>
      ) : null}
    </div>
  );
};

export default Search;
